import { PasswordValidationRule } from '../password-validation';

/**
 * Nature Valley (NAF) password validation rules
 * Requirements (dictionary-driven labels):
 * - contain at least 8 characters
 * - contain at least 1 number
 * - contain at least 1 symbol
 * - contain at least 3 uppercase letters OR at least 3 lowercase letters
 */
export const passwordRules: PasswordValidationRule[] = [
  {
    id: 'nafMinLength8',
    label: 'contain at least 8 characters',
    dictionaryKey: 'Components.MyAccount.ContainsEightCharacters',
    test: (password: string) => password.length >= 8,
  },
  {
    id: 'nafHasNumber',
    label: 'contain at least 1 number',
    dictionaryKey: 'Components.MyAccount.ContainsOneNumber',
    test: (password: string) => /\d/.test(password),
  },
  {
    id: 'nafHasSymbol',
    label: 'contain at least 1 symbol',
    dictionaryKey: 'Components.MyAccount.ContainsOneSymbol',
    test: (password: string) => /[^a-zA-Z0-9]/.test(password),
  },
  {
    id: 'nafHas3UpperOr3Lower',
    label: 'contain at least 3 uppercase letters or 3 lowercase letters',
    dictionaryKey: 'Components.MyAccount.ContainsUppercaseLowerCaseLetters',
    test: (password: string) => {
      const upperCount = (password.match(/[A-Z]/g) || []).length;
      const lowerCount = (password.match(/[a-z]/g) || []).length;
      return upperCount >= 3 || lowerCount >= 3;
    },
  },
];
